import styles from './PositionInfoDialog.module.scss';

import { OpenInNew } from '@mui/icons-material';
import { Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Link } from '@work4all/data';
import { usePermissionsRights } from '@work4all/data/lib/hooks/use-permissions/hooks/use-permissions-rights';

import { PositionConversionHistory } from '@work4all/models/lib/Classes/PositionConversionHistory.entity';
import { BzObjType } from '@work4all/models/lib/Enums/BzObjType.enum';

import {
  currencyAsSign,
  formatAsFloat,
  FormatAsFloatOptions,
} from '@work4all/utils';

import { bzObjToEntityType } from '../../../../../simple-pdf-report/utils';
import { usePositionData } from '../use-position-data';

export const PositionInfoTableRows = (props: {
  positionConversionHistoryList: PositionConversionHistory[];
  bzObjType: BzObjType;
}) => {
  const { bzObjType, positionConversionHistoryList } = props;

  const positionIdList = positionConversionHistoryList.map(
    (x) => x.originalPositionCode
  );

  const { isFullLicenceUser } = usePermissionsRights();

  const data = usePositionData({
    bzObjType,
    positionIdList,
  });

  const { t } = useTranslation();

  return positionConversionHistoryList?.map((conversionItem) => {
    const item = data.data?.find(
      (y) => y.id === conversionItem.originalPositionCode
    );
    const entity = bzObjToEntityType[bzObjType] || bzObjType;
    const currency = currencyAsSign(item?.details?.bz_Currency);
    return (
      <tr key={conversionItem.originalPositionCode}>
        {!item && (
          <td colSpan={9}>
            <Skeleton />
          </td>
        )}
        {item && (
          <>
            <td>
              {isFullLicenceUser ? (
                <Link
                  className={styles.link}
                  target="_blank"
                  to={`/more/entity/${entity}/details/${item.bzObjMemberId}`}
                >
                  {t(`COMMON.${entity.toUpperCase()}`)} {item.details.bz_Number}
                  <OpenInNew style={{ fontSize: '1rem' }} />
                </Link>
              ) : (
                <>
                  {t(`COMMON.${entity.toUpperCase()}`)} {item.details.bz_Number}
                </>
              )}
            </td>
            <td>{item.details.bz_Company_Name}</td>
            <td>{item.number}</td>
            <td>{item.longtext}</td>
            <td className={styles.right}>
              {formatAsFloat(item.amount, defaultNumberFormatOptions)}
            </td>
            <td>{item.unit}</td>
            <td className={styles.right}>
              {formatAsFloat(item.purchasePrice, defaultNumberFormatOptions)}{' '}
              {currency}
            </td>
            <td className={styles.right}>
              {formatAsFloat(item.singlePriceNet, defaultNumberFormatOptions)}{' '}
              {currency}
            </td>
            <td>
              {item.details.bz_Project_Name
                ? `${item.details.bz_Project_Number} | ${item.details.bz_Project_Name}`
                : ''}
            </td>
          </>
        )}
      </tr>
    );
  });
};

const defaultNumberFormatOptions: FormatAsFloatOptions = {
  isFinished: true,
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
};
